import React from 'react';
import { Typography } from '@mui/material';

import DS_BasicCard from 'mui/components/elements/DS_BasicCard';
import DS_ButtonLink from 'mui/components/elements/DS_ButtonLink';
import RichText from 'mui/components/elements/RichText';
import ResponsiveImage from 'mui/components/elements/ResponsiveImage';

import {
  StyledImageWrapper,
  StyledMigrationHeaderWrapper,
  StyledWrapperMigratedUsers,
  StyledDS_ButtonLink,
} from './UserMigratedStyles';

const UserMigrated = ({ migrationTitle, migrationText, downloadAPP, instructions, impressAppImg }) => {
  return (
    <StyledWrapperMigratedUsers>
      <DS_BasicCard>
        <StyledMigrationHeaderWrapper>
          {impressAppImg && (
            <StyledImageWrapper>
              <ResponsiveImage {...impressAppImg} gatsbyImageOptions={{ loading: 'lazy' }} />
            </StyledImageWrapper>
          )}

          <Typography variant="DS_copyBigBold" component="h3">
            {migrationTitle || 'Important: It’s time to transition to Impress!'}
          </Typography>
        </StyledMigrationHeaderWrapper>

        <Typography variant="DS_copyMediumRegular" component="p">
          {migrationText || 'You should now download the Impress app to continue tracking your treatment!'}
        </Typography>

        <StyledDS_ButtonLink>
          <DS_ButtonLink
            buttonSize={false}
            title={downloadAPP?.title || 'download the app'}
            url={downloadAPP?.url || 'https://smile2impress.com/uk/blog/impress-app'}
          ></DS_ButtonLink>
        </StyledDS_ButtonLink>

        {instructions && <RichText document={instructions} />}
      </DS_BasicCard>
    </StyledWrapperMigratedUsers>
  );
};

export default UserMigrated;
